import React from 'react';
import { Link } from 'react-router-dom';

const ArticleTags = ({ tags, className }) => (
  <div className={className}>
    {tags.map((t, i) => (
      <Link
        to={`/app/assignments?q=${t}`}
        key={i}
        className="btn btn-secondary btn-sm mr-2 mb-2 px-4"
      >
        {t}
      </Link>
    ))}
  </div>
);

export default ArticleTags;
